import React from 'react';
import { Elements, RecurlyProvider } from '@recurly/react-recurly';
import { getEnv } from '../../utils/environment';

const RecurlyWrapper: React.FunctionComponent = ({ children }) => (
  <RecurlyProvider publicKey={getEnv().recurlyPublicKey}>
    <Elements>{children}</Elements>
  </RecurlyProvider>
);

export default RecurlyWrapper;
